module.exports = __webpack_public_path__ + "static/media/time_to_cut_cost.0f775376.png";